module.exports = __webpack_public_path__ + "assets/79592e7d602ca6653553f469506f510f.mp3";